import React from 'react';

export const UppercaseFirst = (props: { children: React.ReactNode }) => {
  return (
    <span className="inline-block first-letter:uppercase">
      {props.children}
    </span>
  );
};
